'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('antd/lib/table/style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('./index.less');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StandardTable = function (_PureComponent) {
  _inherits(StandardTable, _PureComponent);

  function StandardTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, StandardTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StandardTable.__proto__ || Object.getPrototypeOf(StandardTable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedId: null
    }, _this.hundleRowClass = function (record) {
      return record._id === _this.state.selectedId ? _index2.default.selected : '';
    }, _this.handleRowClick = function (record) {
      _this.setState({ selectedId: record._id });
      _this.props.onSelect(record._id);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(StandardTable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.data;


      return _react2.default.createElement(
        'div',
        { className: _index2.default.standardTable },
        _react2.default.createElement(_table2.default, Object.assign({
          rowClassName: this.hundleRowClass,
          onRow: function onRow(record) {
            return {
              onClick: function onClick() {
                return _this2.handleRowClick(record);
              }
            };
          },
          bordered: true,
          rowKey: function rowKey(record) {
            return record._id;
          },
          dataSource: data,
          pagination: Object.assign({}, this.props.pagination, { showQuickJumper: true
          }),
          onChange: this.handleTableChange
        }, this.props))
      );
    }
  }]);

  return StandardTable;
}(_react.PureComponent);

StandardTable.propTypes = {
  onChange: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  data: _propTypes2.default.array.isRequired,
  loading: _propTypes2.default.bool.isRequired,
  columns: _propTypes2.default.array.isRequired,
  pagination: _propTypes2.default.object,
  scroll: _propTypes2.default.object
};

StandardTable.defaultProps = {
  onSelect: undefined,
  onChange: undefined,
  pagination: {},
  scroll: {}
};

exports.default = StandardTable;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/StandardTable/index.js
// module id = 634
// module chunks = 0